// Feedbacks Manager Component
import React, { useState, useEffect } from 'react';
import { Trash2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FeedbacksManager = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchFeedbacks(); }, []);

  const fetchFeedbacks = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/feedbacks`, { credentials: 'include' });
      if (response.ok) { const data = await response.json(); setFeedbacks(data || []); }
    } catch (err) { console.error('Error fetching feedbacks:', err); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce feedback ?')) return;
    try {
      await fetch(`${BACKEND_URL}/api/admin/feedbacks/${id}`, { method: 'DELETE', credentials: 'include' });
      fetchFeedbacks();
    } catch (err) { console.error('Error deleting feedback:', err); }
  };

  if (loading) {
    return <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-slate-400" /></div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-light text-slate-800 mb-6">Demandes de Partenariat</h2>
      <div className="space-y-4">
        {feedbacks.map((fb) => (
          <div key={fb.id} className="border border-slate-200 rounded-lg p-4">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <div className="grid grid-cols-2 gap-4 mb-3">
                  <div>
                    <span className="text-xs text-slate-400">Société</span>
                    <p className="font-medium text-slate-800">{fb.company_name || '-'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-slate-400">Contact</span>
                    <p className="font-medium text-slate-800">{fb.full_name || '-'}</p>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-4 mb-3">
                  <div>
                    <span className="text-xs text-slate-400">Email</span>
                    <p className="text-sm text-slate-600">{fb.email || '-'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-slate-400">Téléphone</span>
                    <p className="text-sm text-slate-600">{fb.phone || '-'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-slate-400">Capital</span>
                    <p className="text-sm text-slate-600">{fb.capital || '-'}</p>
                  </div>
                </div>
                {fb.address && (
                  <div className="mb-3">
                    <span className="text-xs text-slate-400">Adresse</span>
                    <p className="text-sm text-slate-600">{fb.address}</p>
                  </div>
                )}
                {fb.message && (
                  <div>
                    <span className="text-xs text-slate-400">Message</span>
                    <p className="text-sm text-slate-600">{fb.message}</p>
                  </div>
                )}
                <p className="text-xs text-slate-400 mt-3">{new Date(fb.created_at).toLocaleString('fr-FR')}</p>
              </div>
              <Button variant="ghost" size="sm" onClick={() => handleDelete(fb.id)}>
                <Trash2 className="w-4 h-4 text-red-500" />
              </Button>
            </div>
          </div>
        ))}
      </div>
      {feedbacks.length === 0 && <div className="text-center py-12 text-slate-500">Aucune demande de partenariat.</div>}
    </div>
  );
};

export default FeedbacksManager;
